// Lightweight client-side event tracker for owner analytics.
// Fire-and-forget; errors are swallowed so they never affect UX.
import api from "./api";

const recentViews = new Map(); // provider_id → timestamp (ms); dedupe profile_view fires within 5 min

export function trackEvent(provider_id, type) {
  if (!provider_id || !type) return;
  if (type === "profile_view") {
    const last = recentViews.get(provider_id);
    if (last && Date.now() - last < 5 * 60 * 1000) return;
    recentViews.set(provider_id, Date.now());
  }
  api.post("/events", { provider_id, type }).catch(() => {});
}
